import { render, staticRenderFns } from "./ChannelsListItem.vue?vue&type=template&id=b7e6a4b4&"
import script from "./ChannelsListItem.vue?vue&type=script&lang=ts&"
export * from "./ChannelsListItem.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelsListItem.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports